/**
 * Shared folder schemas.
 *
 * Every folder domain (agent, deployment, tool, document-template) exposes the
 * same folder shape and CRUD bodies — only the assignment schema differs per
 * domain. Each Z manifest composes these with its own assignment schema.
 */

import { z } from "zod";

export const FolderSchema = z.object({
  id: z.string(),
  name: z.string(),
  iconUrl: z.string().nullable(),
  parentId: z.string().nullable(),
  createdAt: z.string(), // ISO string
  updatedAt: z.string().nullable() // ISO string
});

export type Folder = z.infer<typeof FolderSchema>;

export const FolderPathVarsSchema = z.object({
  id: z.string()
});

export const CreateFolderBodySchema = z.object({
  name: z.string().trim().min(1, "Folder name is required").max(255),
  parentId: z.string().optional()
});

export const UpdateFolderBodySchema = z.object({
  name: z.string().trim().min(1).max(255).optional(),
  parentId: z.string().nullable().optional()
});

export const FolderIconUpdatedSchema = z.object({
  iconUrl: z.string()
});

export const FolderIconRemovedSchema = z.object({
  iconUrl: z.null()
});

export const FolderMutationOkSchema = z.object({
  success: z.literal(true)
});
